import { Button, ErrorListItem } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../../Layout/MainLayout';
import { useUpdateWebhookMutation, useWebhookQuery } from '../../../../api/webhooks';
import { MainBreadcrumbs } from '../../../Layout/MainBreadcrumbs';
import { Route } from '../../../../routes/account.business_.webhooks_.$webhookId';
import { WebhookForm } from './WebhookForm';
import { useCallback } from 'react';
import { useBoolean } from 'usehooks-ts';
import { DeleteWebhookDialog } from './DeleteWebhookDialog';

export function EditWebhookPage() {
  const { t } = useTranslation();
  const navigate = Route.useNavigate();
  const { webhookId } = Route.useParams();
  const webhookQuery = useWebhookQuery({ webhookId });
  const updateWebhookMutation = useUpdateWebhookMutation({ webhookId });
  const deleteFlag = useBoolean(false);

  const goToBusinessPage = useCallback(
    () => navigate({ to: '/account/business', replace: true }),
    [navigate],
  );

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Edit Webhook')}
          loading={webhookQuery.isPending}
          parent={{
            to: '/account/business',
            title: t('Your business'),
          }}
        />
      }
      actions={
        webhookQuery.isSuccess ? (
          <Button variant="outlined" size="small" onClick={deleteFlag.setTrue}>
            {t('Delete')}
          </Button>
        ) : undefined
      }
    >
      {webhookQuery.data ? (
        <WebhookForm mutation={updateWebhookMutation} defaultValues={webhookQuery.data} />
      ) : webhookQuery.error ? (
        <ErrorListItem error={webhookQuery.error} />
      ) : null}
      <DeleteWebhookDialog
        webhook={deleteFlag.value ? webhookQuery.data : undefined}
        onCancel={deleteFlag.setFalse}
        onSuccess={goToBusinessPage}
      />
    </MainLayout>
  );
}
